import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { connect } from 'react-redux'
import env from '../ENV';
import TableComp from '../Components/ReusableTable'
import swal from '@sweetalert/with-react';
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import dateFormater from '../Classes/FormatDate'
import AuthHandler from '../Classes/AuthHandler';
import { postPoTransmittleDocumnetDtails, GetTransmittalDocumentDetails, UpdateTransmittalDocumentDetails } from './../store/actions/expediting.Actions';
import { uploadFileGeneric } from '../store/actions/fileActions'
const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

class POAnnexure extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      transmittleDocumentName: '',
      addDocumentmodal: false,
      PoAnnexure: [],
      indicator: '',
      transmittalFile: [],
      TransmittalDocStatus: {
        0: { title: "Document Submitted", badge: "badge-warning", status: "" },
        1: { title: "Read", badge: "badge-success", status: "Read" },
      },
    }
    this.dataSync = this.dataSync.bind(this)
  }
  componentDidMount() {
    this.dataSync()
  }

  dataSync = async () => {
    var PoAnnexure = []
    await this.props.GetTransmittalDocumentDetails()
    PoAnnexure = await this.props.expediting.getPoTransmittleDOcuments.filter((elem) => elem.POId === 0 && elem.Indicator == 1)
    await this.setState({ PoAnnexure })
  }
  addDocumentmodal(indicator) {
    this.setState({ addDocumentmodal: !this.state.addDocumentmodal, indicator });

    if (this.state.addDocumentmodal == true) {
      this.setState(
        { opacity: "" }
      )
    }
    else {
      this.setState(
        { opacity: "0.2" }
      )
    }
  }
  addDocumentstoList = async (indicator) => {
    // ? inserting new document in the drawing list
    await this.props.postPoTransmittleDocumnetDtails({
      PoId: 0,
      DocumentTypeName: this.state.transmittleDocumentName,
      indicator: indicator,
    })

    // ? setting the document name input to blank
    await this.setState({
      transmittleDocumentName: ''
    })

    // ? syncing data
    await this.dataSync()
    // ? closing modal
    await this.addDocumentmodal()
  }
  setTransmittleDocumentName(event) {
    this.setState({ transmittleDocumentName: event.target.value })
  }
  handleFileForTransmittleDoc(e) {
    let transmittalFile = []
    transmittalFile = e.target.files
    this.setState({ transmittalFile })
  }
  uploadTransmittalFile = async (DocumentDetailsid) => {
    if (this.state.transmittalFile.length < 1) {
      swal("Please upload some valid document", { icon: "error" })
      return false;
    }
    var result = await this.props.uploadFileGeneric([this.state.transmittalFile[0]], AuthHandler.getUserID())
    const input = {
      DocumentDetailsid: DocumentDetailsid,
      DocumentId: result.results[0].DocumentId,
      RoleId: Object.keys(AuthHandler.getRoles())[0],
      GroupId: Object.keys(AuthHandler.getGroups())[0],
      UploadedBy: AuthHandler.getUserID(),
      CreatedOn: result.results[0].CreatedOn
    }
    await this.props.UpdateTransmittalDocumentDetails(input)
    await this.dataSync()
  }
  DeleteTransmittalDocument = async (DocumentDetailsid) => {
    const input = {
        DocumentDetailsid: DocumentDetailsid,
        DocumentId: 0,
        RoleId: 0,
        GroupId: 0,
        UploadedBy: 0,
        CreatedOn: 0,
        isDownloaded: 0,
        DownloadedDate: "",
        delInd: 1,
    }
    await this.props.UpdateTransmittalDocumentDetails(input)
    await this.dataSync()
}
  render() {
    const TransmittalTableConstants = () => {
      return [
        {
          title: 'Document Name',
          className: 'headeralign min-vw-200',
          render: rowData => {
            return <span>{rowData.DocumentName}</span>;
          },
        },
        {
          title: 'Uploaded By',
          className: 'headeralign',
          render: rowData => {
            return <span>{rowData.UploadedByName}</span>;
          },
        },
        {
          title: 'Submitted On',
          className: 'text-center',
          render: rowData => {
            return <span>{rowData.CreatedOn ? dateFormater(rowData.CreatedOn) : '---'}</span>;
          },
        },
        {
          title: 'Actions',
          className: 'text-center',
          render: rowData => {
            if (rowData.DocumentId == null) {
              return (
                <div className="row view-button">
                  <div className="col pt-2">
                    <input type="file" className="form-control-file" onChange={(e) => this.handleFileForTransmittleDoc(e)} id="exampleFormControlFile1" />
                  </div>
                  <div className="col">
                    <FontAwesomeIcon className="align-middle mt-2 pr-2" onClick={() => this.uploadTransmittalFile(rowData.DocumentDetailsid)} icon={"cloud-upload-alt"} title="Upload Invoice" color={"black"} size="2x" />
                  </div>
                </div>
              );
            }
            else {
              return (
                <div className="view-button">
                  <div className="row">
                    <div className="col align-middle">
                      <a href={FILESERVER_ROOT_URL + "files/Documents/" + rowData.DocumentId + "/download"} target="_blank" download>
                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="Download" color={"black"} size="2x" cursor="Pointer" />
                      </a>
                      <FontAwesomeIcon className="align-middle mt-2 pl-2" icon={"trash-alt"} title="Delete" color={"red"} size="2x" cursor="Pointer" onClick={() => this.DeleteTransmittalDocument(rowData.DocumentDetailsid)} />
                    </div>
                  </div>
                  {this.props.expediting && this.props.expediting.getPoTransmittleDOcuments ?
                    (<span className={"badge " + this.state.TransmittalDocStatus[rowData.isDownloaded]['badge']}>
                      {`${this.state.TransmittalDocStatus[[rowData.isDownloaded]]['title']}`}
                    </span>)
                    : null}
                </div>
              )
            }
          },
        },
      ];
    };
    return (
      <div className="Container-fluid p-4">
        {/* Add Document MODAL starts */}
        <Modal isOpen={this.state.addDocumentmodal} >
          <div className={"modal-bg" + (this.state.addDocumentmodal === 'false' ? 'open' : '')}>
            <div className="modalheads">
              <ModalHeader HeaderStyle="modal-header">
                <div><h4 >Add Documents </h4></div>
                <button type="button" className="close" aria-label="Close" onClick={() => { this.addDocumentmodal() }} >
                  <span aria-hidden="true">&times;</span>
                </button>
              </ModalHeader>
            </div>
            <div >
              <ModalBody Style="modal-body">
                <div className="row ml-2 pt-2">
                  <div className="col-md-5"><b>Document Name :</b></div>
                  <div className="col-md-7">
                    <input type="text" className="form-control" value={this.state.transmittleDocumentName} onChange={(e) => this.setTransmittleDocumentName(e)}></input>
                  </div>
                </div>
              </ModalBody>
            </div>
            <div>
              <ModalFooter FooterStyle="modal-footer">
                <div>
                  <button className="btn2 btn-sms3 rounded-pill mt-2 ml-4 float-right" onClick={() => { this.addDocumentmodal() }} type="submit">Cancel</button>
                  <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" onClick={() => { this.addDocumentstoList(this.state.indicator) }} type="submit">Add Document</button>
                </div>
              </ModalFooter>
            </div>
          </div>
        </Modal>
        {/* Add Document MODAL ENDS */}
        <div className="row">
          <div className="col-md-2 header"><b>PO Annexure</b></div>
          <div className="col-md-1">
            <FontAwesomeIcon className="align-middle mt-3" icon={"plus-circle"} title="Add More Documents" color={"blue"} size="lg" onClick={() => this.addDocumentmodal(1)} />
          </div>
        </div>
        <TableComp cols={TransmittalTableConstants()} data={this.state.PoAnnexure} />
      </div>
    )
  }
}



const mapStateToProps = (state) => ({ expediting: state.expediting, file: state.file })
export default connect(mapStateToProps, { postPoTransmittleDocumnetDtails, GetTransmittalDocumentDetails, UpdateTransmittalDocumentDetails, uploadFileGeneric })(POAnnexure)
